import React, { Fragment, useEffect, useState } from "react";
import PageHeader from "../../../../components/PageHeader/PageHeader";
import { ReportsAPI } from "../../../../api/Endpoints/ReportsAPI";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Waveform } from "@uiball/loaders";
import Paper from "@mui/material/Paper";
import { GlobalRefreshContext } from "../../../../contexts/GlobalRefresh/GlobalRefresh";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import SelectX from "../../../../components/Form/SelectX";
import {
  fetchCampaginName,
  fetchLeadSources,
  fetchProjects,
} from "../../../../components/CommonFunctions/DropdownLists";
import { useForm } from "react-hook-form";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DownloadIcon from "@mui/icons-material/Download";

function Index() {
  const { GlobalRefresh } = GlobalRefreshContext();
      const leadTypeData = JSON.parse(sessionStorage.getItem('Lead_type'));
    const projectData = JSON.parse(sessionStorage.getItem('project'));
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);

  const { watch, control, setValue } = useForm();
  useEffect(() => {
    fetchStatusReports();
  }, [
    GlobalRefresh,
    selectedToDate,
    selectedFromDate,
    watch("lead_source"),
    watch("campagin_name"),
  ]);

  const downloadPDF = () => {
    try {
      // Initialize jsPDF with proper settings
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      // Set default font
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      doc.text(
        "WhatsApp Read Leads Report",
        doc.internal.pageSize.getWidth() / 2,
        15,
        {
          align: "center",
        }
      );
      // Add title

      // Prepare table data
      const headers = [["No", "Name", "Phone"]];
      const data =
        reports?.leads?.map((row, index) => [
          index + 1,
          row?.name || "-",
          row?.phone_number || "-",
        ]) || [];

      // Add the table
      // Add the table with minimal styling
      autoTable(doc, {
        startY: 25,
        head: headers,
        body: data,

        theme: "grid",
        styles: {
          font: "helvetica",
          fontSize: 10,
          cellPadding: 3,
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineWidth: 0.1,
        },
        bodyStyles: {
          lineWidth: 0.1,
        },
        margin: { left: 14, right: 14 },
        tableWidth: "auto",
      });

      // Save the PDF
      doc.save("whatsapp-read-leads-report.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    }
  };
  const fetchStatusReports = async () => {
    setLoading(true);
    try {
      const response = await ReportsAPI.getWhatsappReadReport({
        crm_lead_type_id: leadTypeData?.ID,
        project_id: projectData.ID,
        from: selectedFromDate
          ? moment(selectedFromDate).format("YYYY-MM-DD")
          : null,
        to: selectedToDate ? moment(selectedToDate).format("YYYY-MM-DD") : null,
      });

      setReports(response?.data);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const clearDatePicker = () => {
    setValue("campagin_name", null);
    setValue("lead_source", null);
    setSelectedFromDate(null);
    setSelectedToDate(null);
  };

  return (
    <div class="page-cntr">
      <div class="lead-cntr follo-up-cntr ">
        <div class="title-sec">
          <PageHeader title={"Read Leads Report"} />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container direction="row" mb={2}>
              <Grid item xs={3}>
                <div class="follw-dates">
                  <DatePicker
                    value={selectedFromDate}
                    disableFuture
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="From"
                        fullWidth
                      />
                    )}
                    onChange={(newValue) => setSelectedFromDate(newValue)}
                    inputFormat="DD/MM/YYYY"
                  />
                </div>
              </Grid>

              <Grid item xs={3}>
                <DatePicker
                  value={selectedToDate}
                  disableFuture
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="To"
                      fullWidth
                    />
                  )}
                  onChange={(newValue) => setSelectedToDate(newValue)}
                  inputFormat="DD/MM/YYYY"
                />
              </Grid>

              <Grid item xs={1}>
                <IconButton
                  className=""
                  sx={{ ml: 2, mt: 1, background: "white" }}
                  edge="end"
                  onClick={clearDatePicker}
                >
                  <ClearIcon />
                </IconButton>
              </Grid>
              {reports?.leads?.length > 0 && (
                <IconButton
                  sx={{ ml: 2, mt: 1, background: "white" }}
                  onClick={downloadPDF}
                >
                  <DownloadIcon />
                </IconButton>
              )}
          
            </Grid>
          </LocalizationProvider>
        </div>
        {loading ? (
          <Box
            sx={{
              width: "100%",
              marginTop: 10,
              height: 80,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
          </Box>
        ) : (
          <Fragment>
            {reports.leads?.length > 0 ? (
              <Fragment>
                <Typography component={"h3"} fontWeight={500} mb={2}>
                  Total Read Leads Reports: {reports?.count}
                </Typography>
                <TableContainer
                  TableContainer
                  component={Paper}
                  className="reports-table"
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Phone</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reports?.leads.map((row, index) => (
                        <TableRow
                          key={index} // Assuming name is unique, otherwise, use another unique identifier
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>

                          <TableCell component="th" scope="row">
                            {row?.name}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row?.phone_number}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Fragment>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  marginTop: 15,
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography>Read Leads Report</Typography>
              </Box>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default Index;
